import { HostType } from './theme'

type Link = {
  name: string
  href: string
}

type LinkGroup = {
  name: string
  hosts: HostType[]
} & ({ href: string; links?: undefined } | { links: Link[]; href?: undefined })

export const links: LinkGroup[] = [
  { name: 'features', href: '/#features', hosts: ['sellscreen', 'uzum'] },
  {
    name: 'features',
    hosts: ['sellematics'],
    links: [
      { name: 'features_overview', href: '/#features' },
      { name: 'repricer', href: '/repricer/' },
    ],
  },
  { name: 'blog', href: '/articles/', hosts: ['sellematics'] },
  { name: 'pricing', href: '/pricing/', hosts: ['sellmonitor'] },
  { name: 'pricing', href: '/#pricing', hosts: ['sellscreen', 'uzum'] },
  { name: 'faq', href: '/#faq', hosts: ['sellscreen'] },
  {
    name: 'features',
    hosts: ['sellmonitor'],
    links: [
      { name: 'financial_analytics', href: '/financial-analytics/' },
      { name: 'repricer', href: '/repricer/' },
      { name: 'bidder', href: '/bidder/' },
      { name: 'review_autoreplier', href: '/review-autoreplier/' },
      { name: 'supply_planning', href: '/supply-planning/' },
      { name: 'seo_optimization', href: '/seo-optimization/' },
      { name: 'extension', href: '/extension/' },
    ],
  },
  { name: 'consulting', href: '/consulting/', hosts: ['sellmonitor'] },
  { name: 'partner_program', href: '/partner-program/', hosts: ['sellmonitor'] },
  { name: 'blog', href: '/blog/', hosts: ['sellmonitor'] },
  { name: 'about', href: '/about/', hosts: ['sellmonitor', 'sellscreen', 'sellematics'] },
]
